import React, { useEffect } from 'react';

const ICONS = {
  analytics:   '📈',
  marketplace: '💼',
  settings:    '⚙️',
  billing:     '💳',
  help:        '❓',
  admin:       '🛡️',
};

export default function MoreSheet({ open, onClose, items = [], onPick }) {
  useEffect(() => {
    if (!open) return;
    function onKey(e) { if (e.key === 'Escape') onClose?.(); }
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  return (
    <div className={`v4-sheet-wrap ${open ? 'open' : ''}`} aria-hidden={!open}>
      <div className="v4-sheet-backdrop" onClick={onClose} />
      <div className="v4-sheet" role="dialog" aria-label="More">
        <div className="v4-sheet-handle" />
        <button className="v4-sheet-close" onClick={onClose} aria-label="Close">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <line x1="18" y1="6" x2="6" y2="18" /><line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>
        <div className="v4-sheet-head">
          <div className="v4-sheet-title">More</div>
          <div className="v4-sheet-sub">Everything else, one tap away</div>
        </div>
        <div className="v4-more-grid">
          {items.map(it => (
            <button key={it.id} className="v4-more-row v4-glass" onClick={() => { onPick?.(it.view); onClose?.(); }}>
              <span className="v4-more-icon" aria-hidden>{ICONS[it.id] || '•'}</span>
              <span className="v4-more-label">{it.label}</span>
              <span className="v4-more-arrow">→</span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
